import styled, { css } from "styled-components";

const PageContainer = styled.section`
    margin-bottom: 30px;

    .reset-password-inner {
        margin: 50px auto;
        background: #f6f6f6;
        padding: 30px 30px;
    }

    ${(props) =>
        props.theme &&
        css`
            @media (min-width: ${props.theme.breakpoints.md_min}px) {
                .reset-password-inner {
                    max-width: 400px;
                }
            }
        `}

    input {
        box-shadow: none !important;
        border-color: #333;
        padding-right: 35px;
        height: 40px;

        &:focus {
            border-color: #000;
        }
    }

    .icon {
        top: 34px;
        right: 12px;
        font-size: 17px;
    }

    .form-item.has-error {
        > input {
            border-color: #dc3545;
        }
    }

    .default-btn {
        width: 100%;
        border: 2px solid #333;
        font-size: 13px;
        padding: 9px 12px;
        background-color: #333;
        color: #fff;
        height: 40px;
        &:hover {
            background-color: #000;
        }
    }
`;

export { PageContainer };
